import { useSelector } from 'react-redux'
import { Element } from '../../../common/html/element'
import { Icon } from '../../../common/html/icon'
import { Table } from '../../../common/table'
import { valToPercent } from '../../../helpers/value'
import { HandleDetail } from '../../common/handleDetail'
import { SCORE_OPTION } from '../constants'
import { handleBaseCellValue } from '../portfolioProvince/helper'
import { selectCurrentScore } from '../store/slice'
import classes from './index.module.scss'
import { selectScoreYearOfOperation } from './store/slice'

const TableComponent = ({ isDynamicReport }) => {
  const data = useSelector(selectScoreYearOfOperation())
  const currentScore = useSelector(selectCurrentScore)
  const isCreditScore = currentScore === SCORE_OPTION.CREDIT_SCORE

  const schema = [
    {
      colId: 'name',
      title: 'portfolio.segment.YEARS_OF_OPERATION_COL',
      isI18n: true,
      tdStyle: { width: '100%' },
      render: (_, { rowId }) => {
        return (
          <div
            className="dFlex alignItemsCenter gap1"
            style={{
              fontWeight: rowId !== data.length - 1 ? 'normal' : 600,
            }}
          >
            {rowId !== data.length - 1 && (
              <Icon
                className="icon-square cursorDefault"
                style={{ fontSize: 13, color: data[rowId].color }}
              />
            )}
            {data[rowId].analysisIndicatorTypeName}
          </div>
        )
      },
    },
    {
      colId: 'value',
      title: 'portfolio.segment.NUMBER_OF_COMPANIES',
      isI18n: true,
      tdStyle: { textAlign: 'right' },
      render: (_, { rowId }) => {
        return (
          <Element
            style={{
              fontWeight: rowId !== data.length - 1 ? 'normal' : 600,
            }}
          >
            <HandleDetail
              path="PortfolioInsights/Details"
              otherParams={{
                param: {
                  yearOfOperationId: Number(
                    data[rowId].analysisIndicatorTypeId,
                  ),
                },
                isHighlight: false,
              }}
            >
              {data[rowId].numberCompanies}
            </HandleDetail>
          </Element>
        )
      },
    },
    {
      colId: 'percent',
      title: 'portfolio.segment.PERCENT_OF_TOTAL_COMPANIES',
      isI18n: true,
      tdStyle: { textAlign: 'right' },
      render: (_, { rowId, locale }) => {
        return (
          <div
            style={{
              fontWeight: rowId !== data.length - 1 ? 'normal' : 600,
            }}
          >
            {valToPercent(data[rowId].percentCompanies, locale)}
          </div>
        )
      },
    },
    {
      colId: 'Score',
      title: `portfolio.segment.${
        isCreditScore ? 'CREDIT_RISK_SCORE' : 'PERFORMANCE_SCORE'
      }`,
      isI18n: true,
      tdStyle: { textAlign: 'right' },
      render: (_, { rowId, locale }) => {
        const val = isCreditScore
          ? data[rowId].creditRiskScore
          : data[rowId].performanceScore
        return (
          <div
            style={{
              fontWeight: rowId !== data.length - 1 ? 'normal' : 600,
            }}
          >
            {handleBaseCellValue(val, locale)}
          </div>
        )
      },
    },
  ]

  if (isDynamicReport) {
    schema.push({
      colId: 'Score',
      title: `portfolio.segment.${
        !isCreditScore ? 'CREDIT_RISK_SCORE' : 'PERFORMANCE_SCORE'
      }`,
      isI18n: true,
      tdStyle: { textAlign: 'right' },
      render: (_, { rowId, locale }) => {
        const val = !isCreditScore
          ? data[rowId].creditRiskScore
          : data[rowId].performanceScore
        return (
          <div
            style={{
              fontWeight: rowId !== data.length - 1 ? 'normal' : 600,
            }}
          >
            {handleBaseCellValue(val, locale)}
          </div>
        )
      },
    })
  }

  return (
    <div className={classes.table}>
      <Table
        ids={data.map((i) => i.index)}
        schema={schema}
        autoHeightMax={500}
        isDynamicReport={isDynamicReport}
      />
    </div>
  )
}

export default TableComponent
